/* marabu-shabbat.js — נוצר אוטומטית ע"י add_shabbat_mode_2026-09-11.py
 * ‏11/09/2026 15:43. חלונות שבת/חג לפי הדלקת נרות והבדלה בתל אביב (Hebcal,
 * לוח ישראל), מאוחים לרצפים. מכוסה עד 25/12/2027. אין לערוך ידנית —
 * לרענון מריצים את הסקריפט עם --apply. */
(function () {
  'use strict';
  /* [startSec, endSec] בשניות אפוק. הרשימה קצרה (עשרות) — חיפוש לינארי. */
  var W = [[1789140720,1789316760],[1789744980,1789834680],[1789917600,1790007300],[1790349180,1790438940],[1790953440,1791043200],[1791557700,1791647460],[1792162020,1792251780],[1792766340,1792856160],[1793370720,1793460540],[1793975160,1794065040],[1794579720,1794669600],[1795184280,1795274220],[1795788960,1795878960],[1796393700,1796483760],[1796998560,1797088620],[1797603540,1797693540],[1798208520,1798298580],[1798813620,1798903680],[1799418720,1799508780],[1800023880,1800113940],[1800629100,1800719100],[1801234260,1801324260],[1801839420,1801929360],[1802444640,1802534520],[1803049800,1803139680],[1803654900,1803744780],[1804260060,1804349880],[1804865160,1804954980],[1805470260,1805560080],[1806075360,1806165180],[1806680460,1806770280],[1807285500,1807375440],[1807890600,1807980540],[1808322840,1808412780],[1808495700,1808585640],[1808841480,1808931480],[1809100800,1809190800],[1809705900,1809795960],[1810311000,1810401060],[1810916100,1811006220],[1811521140,1811611320],[1812126180,1812216360],[1812644760,1812821400],[1813336140,1813426320],[1813941000,1814031180],[1814545860,1814635980],[1815150600,1815240720],[1815755220,1815845340],[1816359840,1816449900],[1816964340,1817054340],[1817568840,1817658720],[1818173220,1818263100],[1818777540,1818867420],[1819381860,1819471680],[1819986180,1820075940],[1820590440,1820680140],[1821194640,1821284400],[1821798900,1821888600],[1822403160,1822579200],[1823007420,1823097120],[1823180040,1823269800],[1823611680,1823701440],[1824216060,1824305820],[1824820440,1824910200],[1825424820,1825514700],[1826029320,1826119200],[1826633940,1826723820],[1827238560,1827328560],[1827843300,1827933300],[1828448160,1828538160],[1829053080,1829143140],[1829658060,1829748120]];

  var FORCE = /[?&]mrb_shabbat_preview=1/.test(location.search);

  /* רכישה מחו"ל פתוחה גם בשבת (הבעלים, 11/09/2026): החסימה חלה רק על
     גולשים שאזור הזמן של הדפדפן שלהם הוא ישראל. תייר ישראלי בחו"ל —
     פתוח; דפדפן בלי Intl (נדיר) — נחסם, כברירת המחדל השמרנית. */
  var IL = true;
  try {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    IL = tz === 'Asia/Jerusalem' || tz === 'Asia/Tel_Aviv' || tz === 'Israel';
  } catch (e) { }

  function current(t) {
    t = t / 1000;
    for (var i = 0; i < W.length; i++) {
      if (t >= W[i][0] && t < W[i][1]) return W[i];
    }
    return null;
  }
  function blocked() { return FORCE || (IL && !!current(Date.now())); }

  /* בתצוגה מקדימה אין חלון אמיתי — מציגים את הקרוב */
  function shownWindow() {
    var w = current(Date.now());
    if (w) return w;
    var t = Date.now() / 1000;
    for (var i = 0; i < W.length; i++) if (W[i][0] > t) return W[i];
    return null;
  }

  var HE = (document.documentElement.lang || 'he').toLowerCase().indexOf('he') === 0;

  function jlm(d, opts) {
    opts.timeZone = 'Asia/Jerusalem';
    return new Intl.DateTimeFormat(HE ? 'he-IL' : 'en-GB', opts).format(d);
  }

  function texts(w) {
    var end = new Date(w[1] * 1000);
    var day = jlm(end, { weekday: 'long' });
    var time = jlm(end, { hour: '2-digit', minute: '2-digit' });
    /* שבת רגילה: נפתח ביום שישי ואורכו פחות מ-30 שעות. כל השאר — חג. */
    var startDay = new Intl.DateTimeFormat('en-US',
      { weekday: 'short', timeZone: 'Asia/Jerusalem' }).format(new Date(w[0] * 1000));
    var plainShabbat = startDay === 'Fri' && (w[1] - w[0]) < 30 * 3600;
    if (HE) return {
      title: plainShabbat ? 'האתר שלנו נח בשבת' : 'האתר שלנו נח בשבת ובחג',
      body: 'בשבת ובחג לא ניתן להשלים רכישה באתר, אבל אפשר בהחלט להמשיך ' +
            'להתרשם ולהוסיף פריטים לסל — הסל נשמר ומחכה לך.',
      reopen: 'התשלום ייפתח מחדש ב' + day + ' בשעה ' + time + '.',
      greeting: plainShabbat ? 'שבת שלום ✨' : 'שבת שלום וחג שמח ✨',
      button: 'המשך גלישה'
    };
    return {
      title: 'Our boutique rests on Shabbat' + (plainShabbat ? '' : ' & holidays'),
      body: 'Purchases can’t be completed during Shabbat and Jewish holidays, ' +
            'but you’re welcome to keep browsing and add pieces to your cart — ' +
            'it will be saved for you.',
      reopen: 'Checkout reopens on ' + day + ' at ' + time + ' (Israel time).',
      greeting: plainShabbat ? 'Shabbat Shalom ✨' : 'Shabbat Shalom & Chag Sameach ✨',
      button: 'Continue browsing'
    };
  }

  /* ---------- מודל ---------- */
  var modal = null;
  function ensureModal() {
    if (modal) return modal;
    var w = shownWindow();
    if (!w) return null;
    var t = texts(w);
    modal = document.createElement('div');
    modal.className = 'mrb-shabbat-overlay';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', t.title);
    modal.innerHTML =
      '<div class="mrb-shabbat-card" dir="' + (HE ? 'rtl' : 'ltr') + '">' +
        '<div class="mrb-shabbat-candle" aria-hidden="true">🕯️</div>' +
        '<h2 class="mrb-shabbat-title"></h2>' +
        '<p class="mrb-shabbat-body"></p>' +
        '<p class="mrb-shabbat-reopen"></p>' +
        '<p class="mrb-shabbat-greeting"></p>' +
        '<button type="button" class="mrb-shabbat-close button"></button>' +
      '</div>';
    modal.querySelector('.mrb-shabbat-title').textContent = t.title;
    modal.querySelector('.mrb-shabbat-body').textContent = t.body;
    modal.querySelector('.mrb-shabbat-reopen').textContent = t.reopen;
    modal.querySelector('.mrb-shabbat-greeting').textContent = t.greeting;
    var btn = modal.querySelector('.mrb-shabbat-close');
    btn.textContent = t.button;
    btn.addEventListener('click', hideModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) hideModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideModal();
    });
    document.body.appendChild(modal);
    return modal;
  }
  function showModal() {
    var m = ensureModal();
    if (!m) return;
    m.classList.add('is-open');
    var b = m.querySelector('.mrb-shabbat-close');
    if (b) b.focus();
  }
  function hideModal() { if (modal) modal.classList.remove('is-open'); }

  /* ---------- יירוט ---------- */
  var SEL = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]';
  document.addEventListener('click', function (e) {
    if (!blocked()) return;
    var el = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    showModal();
  }, true);
  document.addEventListener('submit', function (e) {
    if (!blocked()) return;
    var f = e.target;
    var action = (f.getAttribute && f.getAttribute('action')) || '';
    var sub = e.submitter;
    if (action.indexOf('/checkout') > -1 || (sub && sub.name === 'checkout')) {
      e.preventDefault();
      e.stopPropagation();
      showModal();
    }
  }, true);

  /* ---------- כפתורי תשלום מהיר של צד שלישי: הסתרה בזמן חלון ---------- */
  function sync() {
    document.documentElement.classList.toggle('mrb-shabbat', blocked());
    var t = Date.now() / 1000, next = null;
    var w = current(Date.now());
    if (w) next = w[1];
    else for (var i = 0; i < W.length; i++) if (W[i][0] > t) { next = W[i][0]; break; }
    var delay = next ? Math.min((next - t + 2) * 1000, 21600000) : 21600000;
    setTimeout(sync, Math.max(delay, 30000));
  }

  var css = document.createElement('style');
  css.textContent =
    'html.mrb-shabbat .additional-checkout-buttons,' +
    'html.mrb-shabbat .cart__dynamic-checkout-buttons,' +
    'html.mrb-shabbat .shopify-payment-button,' +
    'html.mrb-shabbat shopify-accelerated-checkout,' +
    'html.mrb-shabbat shopify-accelerated-checkout-cart{display:none !important}' +
    '.mrb-shabbat-overlay{position:fixed;inset:0;z-index:100000;display:none;' +
      'align-items:center;justify-content:center;padding:2rem;' +
      'background:rgba(23,20,20,.45)}' +
    '.mrb-shabbat-overlay.is-open{display:flex}' +
    '.mrb-shabbat-card{background:#fff;max-width:42rem;width:100%;' +
      'border-top:3px solid #AFBBAD;padding:3rem 2.6rem 2.6rem;text-align:center;' +
      'box-shadow:0 12px 40px rgba(23,20,20,.25);color:#171414;' +
      "font-family:'Assistant',sans-serif}" +
    '.mrb-shabbat-candle{font-size:2.4rem;margin-bottom:1rem}' +
    '.mrb-shabbat-title{margin:0 0 1.2rem;font-size:2rem;font-weight:600;' +
      'letter-spacing:.02em}' +
    '.mrb-shabbat-body{margin:0 0 1rem;font-size:1.5rem;line-height:1.7}' +
    '.mrb-shabbat-reopen{margin:0 0 1.4rem;font-size:1.5rem;font-weight:600}' +
    '.mrb-shabbat-greeting{margin:0 0 2rem;font-size:1.5rem;color:#6F6D6D}' +
    '.mrb-shabbat-close{cursor:pointer}';
  document.head.appendChild(css);
  sync();
})();
